var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseX = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ok5899"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.57,10.06c2.75-2.58,5.33-5.32,8.03-7.95.82-.47,1.68.18,1.39,1.12l-8.64,8.74,8.5,8.52c.65.93-.33,2.03-1.29,1.36l-8.58-8.5L3.23,21.98c-1.01.32-1.63-.7-1.07-1.51l8.49-8.43L2.15,3.51c-.59-.96.23-1.94,1.25-1.4l8.51,8.51c.25.13.51-.42.66-.56Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-x.3550c6b37e82357a461196efb344fd88.svg";